import { useQuery } from "@tanstack/react-query";
import { getConversation } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";

export function useConversation(conversationId, { enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.conversation(conversationId),
    queryFn: () => getConversation(conversationId),
    staleTime: staleTimes.conversationDetail,
    enabled: Boolean(conversationId) && enabled,
  });
}
